<template>
  <div class="common-layout" >
    <el-container>
      <el-header>
        <div style="display:flex;">
          <el-button type="primary" plain @click="add" style=" position: relative ;left:  0px">添加要求</el-button>
          <el-button type="primary" plain @click="goBack" style="position: relative ;left: -10px">上一步</el-button>
<!--          <el-input v-model="search" style="width: 50%" maxlength="50" show-word-limit placeholder="输入检测模板细项名称" clearable>-->
<!--            <template #append>-->
<!--              <el-button type="primary" @click="qSearch">查询</el-button>-->
<!--            </template>-->
<!--          </el-input>-->
        </div>
      </el-header>
      <el-main  style="margin-top: -25px">
        <el-table
            :data="tableData"
            style="width: 100%;height: 475px"
            border
            :row-class-name="tableRowClassName"
        >
          <el-table-column label="操作" min-width="5%">
            <template #default="scope">
              <el-button type="primary" plain size="small" @click="update( scope.row)">编辑</el-button>
              <el-button type="danger" plain size="small" style="margin-left: 3px;" @click="deleteOne( scope.row.askId)">删除</el-button>
            </template>

          </el-table-column>
          <el-table-column prop="ifTrue" min-width="5%" label="要求序号"></el-table-column>
          <el-table-column prop="askName" min-width="30%" label="要求名称"></el-table-column>
<!--          <el-table-column prop="sceneDescr" min-width="40%" label="检测细项模板描述"></el-table-column>-->
        </el-table>
      </el-main>
      <el-footer>
        <div class="demonstration" style="margin: 10px 0">
          <el-pagination v-model:currentPage="currentPage"
                         v-model:page-size="pageSize"
                         :page-sizes="[20, 40,60]"
                         :small="small"
                         :background="background"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total"
                         :prev="prev"
                         :pager="pager"
                         :next="next"
                         :jumper="jumper"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination>
        </div>
        <!--                :disabled="disabled"-->
      </el-footer>
    </el-container>
    <el-dialog v-model="dialogFormVisible" title="添加要求" :lock-scroll="false"
               width="45%" style="margin-top: 30px" draggable>
      <el-form :model="form" ref="form" :rules="rules" status-icon label-width="160px">

        <el-form-item label="要求名称" prop="askName">
          <el-input v-model="form.askName"
                    show-word-limit clearable
                    :autosize="{ minRows: 4, maxRows: 8 }"
                    style="width: 300px"
                    type="textarea" maxlength="1000"></el-input>
        </el-form-item>
        <el-form-item label="要求序号" prop="ifTrue">
          <el-input v-model="form.ifTrue"
                    show-word-limit clearable
                    style="width: 300px"
                    maxlength="50"></el-input>
        </el-form-item>
      </el-form>

      <template #footer>
                      <span class="dialog-footer" >
                        <el-button style="margin-top: -40px" @click="dialogFormVisible = false">关闭</el-button>
                        <el-button style="margin-top: -40px"  type="primary" @click="save('form')"
                        >确认</el-button
                        >
                      </span>
      </template>
    </el-dialog>
    <el-dialog v-model="dialogFormVisibleEdit" title="编辑要求 " :lock-scroll="false"
               width="45%" style="margin-top: 30px" draggable>
      <el-form :model="editform" ref="editform" :rules="rules" status-icon label-width="160px">


        <el-form-item label="要求名称" prop="askName">
          <el-input v-model="editform.askName"
                    show-word-limit clearable
                    :autosize="{ minRows: 4, maxRows: 8 }"
                    style="width: 300px"
                    type="textarea" maxlength="1000"></el-input>
        </el-form-item>
        <el-form-item label="要求序号" prop="ifTrue">
          <el-input v-model="editform.ifTrue"
                    show-word-limit clearable
                    style="width: 300px"
                     maxlength="50"></el-input>
        </el-form-item>

      </el-form>

      <template #footer>
                      <span class="dialog-footer">
                        <el-button style="margin-top: -40px"  @click="dialogFormVisibleEdit = false">关闭</el-button>
                        <el-button style="margin-top: -40px"  type="primary" @click="edit('editform')">确定</el-button>
                      </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "../../util/request";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Ask',
  data() {

    return {
      maxtermId: this.$route.query.maxtermId,
      search: '',
      repeatName: '',//判断名字是否重复
      form: {},
      editform: {},
      dialogFormVisibleEdit: false,
      dialogFormVisible: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      ticket:[], //未分页的数据
      tableData: [],
      rules: {
        askName: [
          {required: true, message: '请输入要求名称', trigger: 'blur'}
        ],
        ifTrue: [
          {required: true, message: '请输入序号', trigger: 'blur'}
        ],

      }
    }
  },
  created() {
    this.load();
  },
  methods: {

    goBack(){
      this.$router.go(-1)
    },

    //添加按钮点击事件
    add() {
      this.dialogFormVisible = true;
    },
    //时间格式
    formatDate(value, fmt) {
      if (value == null || value == ''){
        return ""
      }
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt;
    },
    //页面初始化
    load() {
      request.get('/ask/list?maxtermId='+this.maxtermId).then(res => {
        console.log(res);
        this.ticket = res.data;
        if(this.ticket!=null){
          this.total = this.ticket.length
        }else  this.total =0;

        this.getPageInfo()
      })
    },
    //保持数据
    save(formName) {
      console.log(this.$refs[formName])
      this.$refs[formName].validate((valid) => {
        //valid是检验的结果,bool值 validator: validateSolution_Name,
        console.log("看看")

        if (valid) {

          this.form.maxtermId = this.maxtermId
          request.get('/ask/save',{
            params:{
              askName:this.form.askName,
              ifTrue:this.form.ifTrue,
              maxtermId:this.maxtermId
            }
          }).then(res => {
            console.log(res.code + res.mag + res.date + "save" + res);
            if (res.code  === "0") {
              this.$message({
                message: "添加成功",
                type: "success"
              });
              this.load();
              this.dialogFormVisible = false;
              this.form = {}
            } else {
              this.$message({
                message: "添加失败",
                type: "error"
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //修改数据
    edit(formName) {
      //console.log(this.editform.solution_Lock+"--"+this.editform.solution_StatType+"--"+this.editform.solution_Type)
      this.$refs[formName].validate((valid) => {
        //valid是检验的结果,bool值
        if (valid) {
          request.get('/ask/update',{
            params:{
             askName: this.editform.askName,
              ifTrue:this.editform.ifTrue,
              askId :this.editform.askId
            }
          } ).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "编辑成功",
                type: "success"
              });
              this.load();
              this.dialogFormVisibleEdit = false;
            } else {
              this.$message({
                message: "编辑失败",
                type: "error"
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    //修改按钮点击事件
    update(row) {
      this.dialogFormVisibleEdit = true;
      this.editform = JSON.parse(JSON.stringify(row));

    },
    //删除按钮点击事件
    deleteOne(askId){
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.post('/ask/delete', askId ).then(res =>{
          if (res.code=== "0"){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }else {
            this.$message({
              type: 'info',
              message: '删除失败'
            });
          }
          this.load();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //分页三件套
    // 获取当前页的数据信息
    getPageInfo(){
      //清空pageTicket中的数据
      this.tableData=[];
      // 获取当前页的数据
      for(let i=(this.currentPage-1)*this.pageSize;i<this.total;i++){
        //把遍历的数据添加到pageTicket里面
        this.tableData.push(this.ticket[i]);
        //判断是否达到一页的要求
        if(this.tableData.length===this.pageSize) break;
      }
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize=pageSize;
      //数据重新分页
      this.getPageInfo();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage=pageNum;
      //数据重新分页
      this.getPageInfo()
    },

    tableRowClassName({rowIndex}) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (rowIndex === i) {
          return 'success-row';
        }
      }
      return '';
    }
  }
}
</script>

<style>

</style>